export class HoldingReportTableItem {
  constructor(public id: number = null, public reportPeriod: string = null, public publishDate: Date = null) {}
}
